/**
 * 各列表页顶栏横幅背景（四页各不相同）。
 * 可改为站内路径，例如：'/images/banner-news.jpg'
 */
export const PAGE_BANNER_BG = {
  news:
    'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=2000&q=80',
  products:
    'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=2000&q=80',
  solutions:
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=2000&q=80',
  cases:
    'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=2000&q=80'
}
